export default "__VITE_ASSET__CAAHel4i__"